<template>
<div>
<vue-snotify/>
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div v-if="showHeader=='YES'" class="columns has-background-grey-dark has-text-light">
<div class="column is-12 is-size-4 has-text-weight-bold">{{data_pay[0].nom}}</div>
</div>


<div class="columns">
    <div class="column is-2">
        <div class="columns is-gapless is-multiline">
            <div class="column is-12 doFontSmallest">DUE</div>
            <div class="column is-12 is-size-4 has-text-weight-bold">{{return_money(student_frais_owe)}}</div>
        </div>
    </div>
    <div class="column is-2">
        <div class="columns is-gapless is-multiline">
            <div class="column is-12 doFontSmallest">PAI</div>
            <div class="column is-12 is-size-4 has-text-weight-bold">{{return_money(student_frais_pay)}}</div>
        </div>
    </div>
    <div class="column is-2">
        <div class="columns is-gapless is-multiline">
            <div class="column is-12 doFontSmallest">SOLDE</div>
            <div class="column is-12 is-size-4 has-text-weight-bold">{{return_money(student_frais_solde)}}</div>
        </div>
    </div>

    <div class="column is-2">        
        <a @click="printit()" class="button is-fullwidth is-pulled-right has-background-white"><span class="icon"><i class="fas fa-print"></i></span>&nbsp;&nbsp;Print</a>         
    </div>

    <div class="column is-4 has-text-centered">
        <button @click="paiements_save()" class="button is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>
</div>
 
<!-- OWE  -->
<div class="columns mb-4">
<div class="column is-6 box has-background-light">
<div class="columns is-gapless is-multiline">

<div class="column is-12 is-uppercase has-text-weight-bold underIT">Frais étudiant</div>


<div class="column is-6 is-size-7 mt-3 has-text-grey-light has-text-weight-bold">DESC</div>
<div class="column is-2 is-size-7 mt-3 has-text-grey-light has-text-weight-bold">AMT</div>
<div class="column is-1"><button @click="fee_add_defaults_confirm()" title="Insérer les coûts du programme par défaut" class="button is-small is-fullwidth has-background-light has-text-link"><span class="icon is-small has-text-left"><i class="fas fa-file-invoice-dollar"></i></span></button></div>
<div class="column is-3"><button @click="owe_add()" title="Add Fee" class="button is-small is-fullwidth has-background-success-light has-text-success"><span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span></button></div>



<div class="column is-12">
<div class="columns is-gapless is-multiline" v-for="(data,index) in data_owe" :key="index" style="margin-bottom:0em;">
    <div class="column is-6">
        <input v-model="data.studentFee_DESC" class="input has-text-left has-text-weight-bold">
    </div>
    <div class="column is-2">
        <input v-model="data.studentFee_AMT" class="input has-text-right has-text-weight-bold" type="number">
    </div>
    <div class="column is-3 mt-3 has-text-grey has-text-centered has-text-weight-bold">
        {{ data.studentFee_DATE | moment("add", "1 days","MMM-D-YY") }}
        <!-- <input disabled v-model="" class="input has-text-right has-text-weight-bold" type="text"> -->
    </div>

    <div @keyup.tab="owe_add()" class="column is-1 has-background-danger-light">
        <button @click="owe_delete_confirm(index)" class="button is-fullwidth has-background-danger-light">
            <span class="icon is-small">
                <i class="fas fa-trash"></i>
            </span>
        </button>
    </div>

</div></div></div></div> <!-- END COL 6 / LOOP  -->

<div class="column is-6">
<div class="columns is-centered">
    <div class="column is-10">
        <textarea v-model="student_frais_comments" rows="2" class="textarea is-size-5 has-text-weight-semibold" placeholder="Note...."></textarea>
    </div>
</div></div>  <!-- END COL 6 / NOTES  -->


</div> <!-- END MAIN EVERYTHING  -->
<!-- END OWE  -->


<!-- PAI  -->
<div class="columns is-multiline mt-4 mb-4">




<div class="column is-12 box has-background-light">

<div class="columns is-gapless is-multiline" style="margin-bottom:0em;">
    <div class="column is-12 is-uppercase has-text-weight-bold underIT">Paiements</div>

<div class="column is-2 is-size-7 mt-3 has-text-grey-light has-text-weight-bold">AMT</div>
<div class="column is-2 is-size-7 mt-3 has-text-grey-light has-text-weight-bold">DATE</div>
<div class="column is-1 is-size-7 mt-3 has-text-right has-text-grey-light has-text-weight-bold">RECU</div>
<div class="column is-2 is-size-7 mt-3 has-text-centered has-text-grey-light has-text-weight-bold">DT RECU</div>
<div class="column is-1 is-size-7 mt-3 has-text-centered has-text-grey-light has-text-weight-bold">TYPE</div>
<div class="column is-1 is-size-7 mt-3 has-text-centered has-text-grey-light has-text-weight-bold">NOTES</div>

    <div class="column is-3"><button @click="pay_add()" title="Add Fee" class="button is-small is-fullwidth has-background-success-light has-text-success"><span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span></button></div>
</div>

<div class="columns is-gapless is-multiline" v-for="(data,index) in data_pay" :key="index" style="margin-bottom:0em;">

    <div class="column is-2">
        <input v-model="data.payment_Amount" class="input has-text-right has-text-weight-bold" type="number">
    </div>
    <div class="column is-2">
        <flat-pickr 
            class="input is-grey has-text-weight-bold has-text-centered"
            :config="config_pick"
            v-model="data.payment_DueDate"
            placeholder="" 
            name="dtDue">
        </flat-pickr> 
    </div>
    <!-- <div class="column is-1 has-background-light"></div> -->

    <div class="column is-1 mt-3 has-text-right" style="">
        <input v-model="data.payment_Rec" type="checkbox">&nbsp;&nbsp;&nbsp;
    </div>

    <div class="column is-2">
        <flat-pickr
            class="input is-grey has-text-weight-bold has-text-centered"
            :config="config_pick"
            v-model="data.payment_RecDate"
            placeholder="" 
            name="dtRec">
        </flat-pickr> 
    </div>


    <div class="column is-1 has-text-centered">
        <input v-model="data.payment_Type" class="input has-text-centered has-text-weight-bold" type="text">
    </div>


    <div class="column is-3">
        <input v-model="data.payment_COMMENTS" class="input has-text-weight-bold" type="text">
    </div>


    <div @keyup.tab="pay_add()" class="column is-1 has-background-danger-light">
        <button @click="pay_delete_confirm(index)" class="button is-fullwidth has-background-danger-light">
            <span class="icon is-small">
                <i class="fas fa-trash"></i>
            </span>
        </button>
    </div>

</div>
</div></div>
<!-- END PAI  -->

<div v-if="show_print">
    <PrintAccount @emit_pdf_done="emit_pdf_done" :studentID="this.studentID" :fees="this.data_owe" :payments="this.data_pay" :key="randomKey()"></PrintAccount>
</div>



  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import PrintAccount  from '@/components/print/print_account_statement';

export default {
  name: 'stud_pai',
  components: { PrintAccount },
  props: [ 'studentID', 'showHeader'  ],

    data() {
        return {
            isLoading:false,
            data_pay:[],
            data_owe:[],
            data_fees_program:[],
            student_frais_comments:'',

student_frais_owe:0,
student_frais_pay:0,
student_frais_solde:0,

           config_pick: { // FLATPICKER
                altFormat: "M j, y",
                altInput: true
            },

show_print:false

        }
    },
 
mounted() {
    this.paiements_load()
}, // END MOUNTED

methods: {


paiements_load:function() {

this.isLoading = true
var query = "SELECT prog_ID,student_frais_owe,student_frais_pay,student_frais_solde, MyMEQ_STUDENT_FEES.* FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_FEES ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_FEES.student_ID WHERE MyMEQ_STUDENT.student_ID = " + this.studentID + " ORDER BY studentFee_DATE, studentFee_ID"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query)) 
.then(res => { 
    this.data_owe = res.data

    if (res.data[0].student_frais_owe) {this.student_frais_owe = res.data[0].student_frais_owe}
    if (res.data[0].student_frais_pay) {this.student_frais_pay = res.data[0].student_frais_pay}
    if (res.data[0].student_frais_solde) {this.student_frais_solde = res.data[0].student_frais_solde}

    if (!(parseFloat(this.data_owe[0].studentFee_ID) > 0)) {
        this.data_owe[0].studentFee_ID = 0 
        this.data_owe[0].studentFee_AMT = 0 
        this.data_owe[0].studentFee_DATE = moment().subtract(1,"days")
        this.data_owe[0].studentFee_DESC = ''
    }

// GET PAYMENTS & PAI COMMENTS !
var query = `SELECT MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_lNAME + ',  ' + MyMEQ_STUDENT.student_fNAME AS nom,student_frais_comments, payment_ID,  payment_Number, payment_Amount, DATEADD(day, 1, payment_DueDate) AS  payment_DueDate, payment_Type, payment_Rec, DATEADD(day, 1, payment_RecDate) AS  payment_RecDate, payment_RecType, 
deposit_ID, payment_NSFREF, payment_COMMENTS, payment_StatusVEN, payment_DESC FROM MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_PAYMENT ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_PAYMENT.student_ID WHERE (MyMEQ_STUDENT.student_ID = '` + this.studentID + `') 
ORDER BY payment_DueDate, payment_ID`

console.log(query)

    this.isLoading=true;
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_pay = res.data

        if (!(parseFloat(this.data_pay[0].payment_ID) > 0)) {
            this.data_pay[0].payment_ID = 0 
            this.data_pay[0].payment_Amount = 0 
            this.data_pay[0].payment_DueDate = moment().format('YYYY-MM-DD') 
            this.data_pay[0].payment_Rec = false
            this.data_pay[0].payment_COMMENTS = ''
            this.data_pay[0].payment_Type = ''
        } // FOR SAVE 

        if (res.data[0].student_frais_comments) {
            this.student_frais_comments = res.data[0].student_frais_comments
        }

        this.isLoading = false
    }); });

}, // END LOAD





paiements_save:function() {
this.isLoading = true;
// ONE BIG LONG STRING

var doReload = false // IF THERE IS AN INSERT -- RELOAD (?)

this.student_frais_owe=0
this.student_frais_pay=0
this.student_frais_solde=0


var queryFRAIS = ''
for(var i = 0; i < this.data_owe.length; i++ ){
    // CHECK THAT HAVE VALUE
    if (this.data_owe[i].studentFee_AMT > 0) {
        this.student_frais_owe += parseFloat(this.data_owe[i].studentFee_AMT)
        if (this.data_owe[i].studentFee_ID == 0) {
            queryFRAIS += "INSERT INTO MyMEQ_STUDENT_FEES (student_ID,studentFee_DATE,studentFee_DESC,studentFee_AMT) VALUES (" + this.studentID + ",'" + moment().format('YYYY-MM-DD') + "','" + this.data_owe[i].studentFee_DESC.replace(/'/g,"''") + "'," + this.data_owe[i].studentFee_AMT + ")"
            queryFRAIS += " ; "
            doReload = true
        } else {
            queryFRAIS += "UPDATE [MyMEQ_STUDENT_FEES] "
            queryFRAIS += " SET "
            // query += " [studentFee_DATE] = '" + moment().format('YYYY-MM-DD')
            queryFRAIS += " [studentFee_DESC] = '" + this.data_owe[i].studentFee_DESC.replace(/'/g,"''")
            queryFRAIS += "',[studentFee_AMT] = " + this.data_owe[i].studentFee_AMT
            queryFRAIS += " WHERE studentFee_ID = " + this.data_owe[i].studentFee_ID
            queryFRAIS += " ; "
        }
    } // END CHECKING IF HAS AMOUNT
} // END FOR


var queryPAI = ''

for(var i = 0; i < this.data_pay.length; i++ ){

// CHECK THAT HAVE VALUE
if (this.data_pay[i].payment_Amount > 0) {


//TOTAL PAI
if (+this.data_pay[i].payment_Rec == true)
{this.student_frais_pay += parseFloat(this.data_pay[i].payment_Amount)}



var dtRECU
if (moment(this.data_pay[i].payment_RecDate).isValid()) { dtRECU = "'" + moment(this.data_pay[i].payment_RecDate).format('YYYY-MM-DD') + "'"} else {dtRECU = null}

    if (this.data_pay[i].payment_ID == 0) {
        // var query = "INSERT INTO MyMEQ_STUDENT_PAYMENT (student_ID,payment_Rec) VALUES (" + this.studentID + ",0)"

    queryPAI += ` INSERT INTO [MyMEQ_STUDENT_PAYMENT] ([student_ID],[payment_Number],[payment_Amount],[payment_DueDate],[payment_Type],[payment_Rec],[payment_RecDate],[payment_COMMENTS])
     VALUES ( ` + this.studentID + `,` + i + `,` + this.data_pay[i].payment_Amount + `,'`
     + moment(this.data_pay[i].payment_DueDate).format('YYYY-MM-DD') + `','` + this.data_pay[i].payment_Type + `',`
     + +this.data_pay[i].payment_Rec + `,` + dtRECU + `,'` +  this.data_pay[i].payment_COMMENTS.replace(/'/g, "''")  + `') `

    queryPAI += " ; "

    doReload = true

        
    } else {

        queryPAI += "UPDATE myMEQ_STUDENT_PAYMENT SET " 
        queryPAI += " payment_Amount = " + this.data_pay[i].payment_Amount
        queryPAI += ", payment_DueDate = '" + moment(this.data_pay[i].payment_DueDate).format('YYYY-MM-DD')
        queryPAI += "', payment_Type = '" + this.data_pay[i].payment_Type + "'"
        queryPAI += ", payment_Rec = " + +this.data_pay[i].payment_Rec 
        queryPAI += ", payment_RecDate = " + dtRECU
        queryPAI += ", payment_COMMENTS = '" +  this.data_pay[i].payment_COMMENTS.replace(/'/g, "''")  + "' "
        queryPAI += " WHERE payment_ID = " + this.data_pay[i].payment_ID
        queryPAI += " ; "

    }

} // END CHECKING AMOUNT

} // END FOR



this.student_frais_solde = parseFloat(this.student_frais_owe) - parseFloat(this.student_frais_pay)


var queryUpdate = ` UPDATE myMEQ_STUDENT SET student_frais_owe = ` + this.student_frais_owe + `, student_frais_pay = ` + this.student_frais_pay + `, student_frais_solde = ` + this.student_frais_solde + `,student_frais_comments = '` + this.student_frais_comments.replace(/'/g,"''") + `' WHERE student_ID = ` + this.studentID


// console.log('888888888888888888888888888888')
// console.log(query)
// console.log('888888888888888888888888888888')

let formData = new FormData();
// formData.append('query', encodeURIComponent(queryFRAIS));
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(queryFRAIS)},
})
.then(res => {

setTimeout(() => {  

console.log('bck 1')

let formData = new FormData();
// formData.append('query', encodeURIComponent(queryPAI));
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(queryPAI)},
})
.then(res => {

setTimeout(() => { 


console.log('bck 2 ----')

let formData = new FormData();
// formData.append('query', encodeURIComponent(queryUpdate));
axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(queryUpdate)},
})
.then(res => {

    this.isLoading = false;
    this.$snotify.success('Saved !!', {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: false}); 
    this.$emit('emit_fee_change', this.student_frais_solde)
    if (doReload) {this.paiements_load()}


}, 750);

}, 750);


})  })  })




},




owe_add:function() {
    var obj = {};
    obj.studentFee_ID = 0
    obj.studentFee_DESC = ''
    obj.studentFee_AMT = 0
    obj.studentFee_DATE = moment().subtract(1,"days")
    this.data_owe.push(obj)
},
pay_add:function() {
    var obj = {};
    obj.payment_ID = 0
    obj.payment_Amount = 0
    obj.payment_DueDate = moment().format('YYYY-MM-DD')
    obj.payment_Type = ''
    obj.payment_Rec = false
    obj.payment_RecDate = null
    obj.payment_COMMENTS = ''
    this.data_pay.push(obj)
},


owe_delete_confirm:function(index) {
    this.$snotify.confirm('DELETE FRAIS?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.owe_delete_do(toast, index)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]
    });
},
owe_delete_do:function(toast, index) {
    this.isLoading=true;
    this.$snotify.remove(toast.id)

// CHECK IF SAVED -- IF NO, JUST SPLICE THAT SH*T
if (this.data_owe[index].studentFee_ID == 0)
{ this.data_owe.splice(index,1) ; return }


var query = "DELETE FROM MyMEQ_STUDENT_FEES WHERE studentFee_ID = " + this.data_owe[index].studentFee_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.data_owe.splice(index,1)

// GET NEW TOTALS
    this.student_frais_owe=0
    for(var i = 0; i < this.data_owe.length; i++ ){
        this.student_frais_owe += parseFloat(this.data_owe[i].studentFee_AMT)
    }

    this.student_frais_solde = parseFloat(this.student_frais_owe) - parseFloat(this.student_frais_pay)
    query = ` UPDATE myMEQ_STUDENT SET student_frais_owe = ` + this.student_frais_owe + `, student_frais_pay = ` + this.student_frais_pay + `, student_frais_solde = ` + this.student_frais_solde + ` WHERE student_ID = ` + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.isLoading=false;

    });    });
},






pay_delete_confirm:function(index) {
    this.$snotify.confirm('DELETE PAIEMENT?', { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
    position: "centerCenter",
        buttons: [
            {text: 'Yes', action: (toast) => this.pay_delete_do(toast, index)},
            {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
        ]
    });
},
pay_delete_do:function(toast, index) {
    this.$snotify.remove(toast.id)
    this.isLoading=true;

    // CHECK IF SAVED -- IF NO, JUST SPLICE THAT SH*T
    if (this.data_pay[index].payment_ID == 0)
    { this.data_pay.splice(index,1) ; return }

    var query = "DELETE FROM MyMEQ_STUDENT_PAYMENT WHERE payment_ID = " + this.data_pay[index].payment_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
    this.data_pay.splice(index,1)

    this.student_frais_pay=0
    for(var i = 0; i < this.data_pay.length; i++ ){
        if (+this.data_pay[i].payment_Rec == true)
        {this.student_frais_pay += parseFloat(this.data_pay[i].payment_Amount)}
    }
    this.student_frais_solde = parseFloat(this.student_frais_owe) - parseFloat(this.student_frais_pay)
    query = ` UPDATE myMEQ_STUDENT SET student_frais_owe = ` + this.student_frais_owe + `, student_frais_pay = ` + this.student_frais_pay + `, student_frais_solde = ` + this.student_frais_solde + ` WHERE student_ID = ` + this.studentID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        this.isLoading=false;

    });    });

    
},





// FEES ************************
fee_add_defaults_confirm:function() {
// CHECK IF HAS PROGRAM -- FOR DEFAULT PAYMENTS
    if (this.data_owe.length < 0) {alert('No Program!') ; return}
    if (isNaN(this.data_owe[0].prog_ID)) {alert('No Program!') ; return}


    this.$snotify.html(`<div class="snotifyToast__title"><b>Insert Default Fees?</b></div>
  <div class="snotifyToast__body">`+ '' +`</div> ` , {
    timeout: 20000, showProgressBar: true, closeOnClick: false, pauseOnHover: true,position:"centerCenter", type:'info',
        buttons: [
            {text: 'Ok', action: (toast) => this.fee_add_defaults_do(toast), bold: true},
            {text: 'Cancel', action: (toast) => {this.$snotify.remove(toast.id); }, bold: true},
        ]
    });
},
fee_add_defaults_do:function(toast) {
    this.isLoading = true
    this.$snotify.remove(toast.id);
// GET FEES
var cour_fees = 0 
    var query = "SELECT * FROM MyMEQ_PROGRAM_FEES WHERE prog_ID = " + this.data_owe[0].prog_ID
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_fees_program = res.data
        query = ''
        for(var i = 0; i < this.data_fees_program.length; i++ ){

// GET TOTAL
cour_fees += parseFloat(this.data_fees_program[i].progFee_AMT)


            query += "INSERT INTO MyMEQ_STUDENT_FEES (student_ID,studentFee_DATE,studentFee_DESC,studentFee_AMT) VALUES ("
            query += this.studentID + ",'" + moment().format('YYYY-MM-DD') + "','" + this.data_fees_program[i].progFee_DESC.replace(/'/g,"''") + "'," + this.data_fees_program[i].progFee_AMT + ");"
        } // END FOR

 

this.student_frais_owe = parseFloat(cour_fees) + parseFloat(this.student_frais_owe)
this.student_frais_solde = parseFloat(this.student_frais_owe) - parseFloat(this.student_frais_pay)
query += ` UPDATE myMEQ_STUDENT SET student_frais_owe = ` + this.student_frais_owe + `, student_frais_pay = ` + this.student_frais_pay + `, student_frais_solde = ` + this.student_frais_solde + ` WHERE student_ID = ` + this.studentID

console.log(query)

        let formData = new FormData();
        formData.append('query', encodeURIComponent(query));
        axios({
            method: 'post',
            url: this.$url+sessionStorage.getItem('url_query_form'),
            data: {
                query:encodeURIComponent(query)
            },
            
        })
        .then(res => {
            // GE-GET FEES
            var query = "SELECT prog_ID,student_frais_owe,student_frais_pay,student_frais_solde, MyMEQ_STUDENT_FEES.* FROM  MyMEQ_STUDENT LEFT OUTER JOIN MyMEQ_STUDENT_FEES ON MyMEQ_STUDENT.student_ID = MyMEQ_STUDENT_FEES.student_ID WHERE MyMEQ_STUDENT.student_ID = " + this.studentID + " ORDER BY studentFee_DATE"
            axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query)) 
            .then(res => { 
                this.data_owe = res.data
                this.$emit('emit_fee_change', this.student_frais_solde)
                this.isLoading = false;

    });   });   });


},

emit_pdf_done:function() {
    this.show_print = false
},

 printit() {
     this.show_print = true
 },

// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},
return_money:function(val) {
// if (!val) {return '$0.00'}

 var ret = parseFloat(val).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
if (ret.isNaN) {return 0}
else {return '$' + ret}


    // try {return '$' + parseFloat(val).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");}
    // catch(err) {return ''}   
},


}, // END METHODS

} // END EXPORT
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
